var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEggNoShadow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 304.53 434.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffcf00;}.cls-2{fill:#4c5859;fill-rule:evenodd;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_10",
    cx: -38.92,
    cy: 653.22,
    r: 300.49,
    gradientTransform: "translate(173.55 405.99) scale(0.55 0.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c5859",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#4c5859",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4c5859",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c5859",
    stopOpacity: 0
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152.27,434.09C-107.44,434.09,15,0,152.27,0S412,434.09,152.27,434.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200.19,64.69c1.64.5-14.82,53.42-15.08,65.13s12.26,18.29,15.7,32.64c.77,11.29-6,19.79-4.64,27.85,1.9,11.18,19.45,7.56,21.05,18.16-1.12,12.84-9.56,20.07-11.77,31.78,4.06,1.25,7.31,1.17,8.13,2.34S178.44,295,182.23,306.46c-7.09-8.3,2.77-19.59,7-27.86,4.79-9.45,10.43-18.16,12.78-27.89-.64-2.82-7.53.52-7-3.47,2.38-13.89,12.2-28,10.62-35.58.69-3.63-15.46-16.06-28.13-23.38-8.84-5.12-12-10.35-43.22-8.9-2.44.11-8.45-1.93-7.8-6.48,7.63,11.55,21.56-3.05,34.84,0,10.91,2.51,23.06,8.58,26.77,8.22,2.24-3.78,6.64-7.4,4.62-16.35-1.88-8.05-12.58-13.23-15.13-24.39-3.09-13.59,7-39.49,7-39.49S198.57,64.2,200.19,64.69Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEggNoShadow);
export default __webpack_public_path__ + "static/media/egg_no_shadow.a86c2e8509c468f2074a231b46ea8f65.svg";
export { ForwardRef as ReactComponent };